var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWarningAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "#E5E5E5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3318_11753)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 844,
    transform: "translate(-35 -152)",
    fill: "#F5F6F8"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -19.5,
    y: -32.5,
    width: 359,
    height: 96,
    rx: 4.5,
    fill: "#FDF8EB",
    stroke: "#F6E0B4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#FEC022"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.25 10C17.25 9.44687 16.8031 9 16.25 9C15.6969 9 15.25 9.44687 15.25 10V18C15.25 18.5531 15.6969 19 16.25 19C16.8031 19 17.25 18.5531 17.25 18V10ZM16.25 23C16.9406 23 17.5 22.4406 17.5 21.75C17.5 21.0594 16.9406 20.5 16.25 20.5C15.5594 20.5 15 21.0594 15 21.75C15 22.4406 15.5594 23 16.25 23Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3318_11753"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 390,
    height: 844,
    fill: "white",
    transform: "translate(-35 -152)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningAlert);
export default __webpack_public_path__ + "static/media/warning-alert.f28d652aaba268d2a16798412b82c53d.svg";
export { ForwardRef as ReactComponent };